import { selectExportFileName, selectIsApproved } from "../store/selectors";
import { isDigitalRow, isUserFileDocument, type ServitutRow } from "../model/row";

function servitutBodyTexts(servitut: any): string[] {
   const tekster: string[] = [];
   if (Array.isArray(servitut?.tekster)) {
      tekster.push(...servitut.tekster.map((t: any) => t?.tekst ?? t).filter(Boolean));
   }
   if (servitut?.tekstSummarisk) {
      tekster.push(servitut.tekstSummarisk);
   }
   return tekster;
}

export function toTxtFileName(fileName: string): string {
   return fileName.replace(/\.[^.]+$/i, "") + ".txt";
}

export function selectServitutBodyText(row: ServitutRow): string {
   const texts = servitutBodyTexts(row.landRegistry.servitut);
   return (texts.join("\n\n") || row.landRegistry.summary || "").trim();
}

export function buildUnavailableServitutTxt(row: ServitutRow): string {
   const name = toTxtFileName(selectExportFileName(row)).replace(/\.txt$/i, "");
   const text = selectServitutBodyText(row) || "Ingen servituttekst.";
   return `${name}\n\n${text}`;
}

export function shouldExportSourceDocument(row: ServitutRow): boolean {
   if (!selectIsApproved(row)) {
      return false;
   }
   if (isDigitalRow(row) && !isUserFileDocument(row)) {
      return true;
   }
   if (row.document.kind === "annotation" || row.document.kind === "upload") {
      return Boolean(row.document.s3Key);
   }
   return row.document.kind === "tingbog_akt" && row.pages.selected.length > 0;
}
